module.exports = __webpack_public_path__ + "media/images/ask-cindy-bg-a8a89b18504c6a872af8c3a9a2c7f120.png";